import { ViewBooking, ViewBookingFromJSONTyped } from "collins-js-sdk";
import { CustomFieldTag } from "../types/bookings";

/**
 * Custom wrapper for ViewBookingFromJSONTyped that preserves the tags field
 * This is needed because the collins-js-sdk doesn't include tags, customer_labels, or preorders in its JSON parsing
 */
export function ViewBookingFromJSONWithAdditionalProps(json: any): ViewBooking {
  const viewBooking = ViewBookingFromJSONTyped(json, false);

  if (json?.tags) {
    (viewBooking as any).tags = json.tags as CustomFieldTag[];
  }

  if (json?.customer_labels) {
    (viewBooking as any).customer_labels = json.customer_labels;
  }

  if (json?.preorders) {
    (viewBooking as any).preorders = json.preorders;
  }

  return viewBooking;
}
